import { Button, Row } from '@ahmdigital/ui';
import styled from 'styled-components';

export const OptionContainer = styled.div`
  position: relative;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    height: 100%;
  }
`;

type OptionBoxProps = {
  isHighlighted?: boolean;
};

export const OptionBox = styled.div<OptionBoxProps>`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  padding: 1.5rem 2.5rem 1.5rem;
  background-color: ${({ isHighlighted, theme: { colors } }) => (isHighlighted ? colors.purpleTint : colors.grey10)};
  border: 1px solid ${({ isHighlighted, theme: { colors } }) => (isHighlighted ? colors.purple : colors.grey10)};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    min-height: 18.75rem;
  }
`;

export const OptionContentRow = styled(Row)`
  flex-direction: column;
`;

export const OptionButtonRow = styled(OptionContentRow)`
  flex-wrap: nowrap;
  margin-top: auto;
  padding-inline: 0;
`;

export const OptionButton = styled(Button)<{ $noWrap?: boolean }>`
  align-self: center;
  margin-right: 0;

  ${({ $noWrap }) => $noWrap && 'white-space: nowrap;'}
`;
